import { render, staticRenderFns } from "./setReference.vue?vue&type=template&id=160cd65b&scoped=true"
import script from "./setReference.vue?vue&type=script&lang=js"
export * from "./setReference.vue?vue&type=script&lang=js"
import style0 from "./setReference.vue?vue&type=style&index=0&id=160cd65b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160cd65b",
  null
  
)

export default component.exports